<template>
  <!-- 2026-08-28：仅渲染编辑内容，描述项必须由订单页面直接声明，避免 Ant Design 忽略包装组件。 -->
  <div class="order-comment-editor">
    <a-textarea
      v-model:value="draft"
      :maxlength="200"
      :placeholder="generateTitle('请输入备注/留言信息')"
      :auto-size="{ minRows: 2, maxRows: 5 }"
      show-count
    />
    <div class="editor-actions">
      <a-button type="primary" size="small" :loading="saving" :disabled="!canSave" @click="saveComment">
        {{ generateTitle('保存') }}
      </a-button>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref, watch } from 'vue'
import { message } from 'ant-design-vue'
import orderRequest from '@/api/orders'
import { generateTitle } from '@/utils/lang'

export default defineComponent({
  name: 'OrderCommentEditor',
  props: {
    detailId: {
      type: Number,
      required: true
    },
    modelValue: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    // 2026-08-26：所有管理端订单详情复用同一必填编辑器，保存主单留言且不触碰量体备注。
    const draft = ref('')
    const saving = ref(false)
    watch(
      () => [props.detailId, props.modelValue],
      () => {
        draft.value = props.modelValue || ''
      },
      { immediate: true }
    )
    const normalizedComment = computed(() => draft.value.trim())
    const canSave = computed(() => props.detailId > 0 && normalizedComment.value.length > 0 && !saving.value)
    const saveComment = async () => {
      if (!normalizedComment.value) {
        message.warning(generateTitle('请输入备注/留言信息'))
        return
      }
      saving.value = true
      try {
        const response = await orderRequest.updateOrderComments({
          orderDetailId: props.detailId,
          comments: normalizedComment.value,
          // 2026-08-27：提交当前页面看到的原值，避免多人同时编辑时静默覆盖后保存的留言。
          expectedComments: props.modelValue || ''
        })
        const savedComment = typeof response.data === 'string' ? response.data : normalizedComment.value
        draft.value = savedComment
        emit('update:modelValue', savedComment)
        message.success(generateTitle('备注/留言信息保存成功'))
      } catch (error: any) {
        // 2026-08-27：保存失败必须展示后端原因，避免请求异常时用户只看到按钮没有反应。
        const errorMessage = error?.message || error?.msg || generateTitle('备注/留言信息保存失败，请稍后重试')
        message.error(errorMessage)
      } finally {
        saving.value = false
      }
    }
    return { draft, saving, canSave, saveComment, generateTitle }
  }
})
</script>

<style scoped lang="scss">
.order-comment-editor {
  width: 100%;
}

.editor-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 8px;
}
</style>
